import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@alfresco/adf-core';
import { CONTENT_NODE_SHARE_DIRECTIVES } from '@alfresco/adf-content-services';

import { WkShareDocumentComponent } from './wk-share-document.component';

@NgModule({
  imports: [CoreModule, CommonModule, ...CONTENT_NODE_SHARE_DIRECTIVES],
  declarations: [WkShareDocumentComponent],
  exports: [WkShareDocumentComponent],
})
export class WkShareDocumentModule {}
